import { render, staticRenderFns } from "./SelectProjectsList.vue?vue&type=template&id=9c0cf788"
import script from "./SelectProjectsList.vue?vue&type=script&lang=js"
export * from "./SelectProjectsList.vue?vue&type=script&lang=js"
import style0 from "./SelectProjectsList.vue?vue&type=style&index=0&id=9c0cf788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports